import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/minimal.png";
import "../stylesheets/navbar.css";

function Navbar({ visible }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className={`navbar ${visible ? "visible" : ""}`}>
      <div className="navbar-content">
        <div className="navbar-left">
          <img src={logo} alt="SICOR Logo" className="navbar-logo" />
          <span className="navbar-title">SICOR Ventas y Servicios</span>
        </div>

        {/* Links escritorio */}
        <div className="navbar-links">
          <Link to="/">Inicio</Link>
          <Link to="/servicios">Productos</Link>
          <Link to="/nosotros">Quiénes Somos</Link>
          <Link to="/contacto">Contacto</Link>
        </div>

        {/* Botón hamburguesa móvil */}
        <button
          className={`navbar-hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menú"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Menu móvil */}
      <div className={`navbar-mobile-menu ${menuOpen ? "open" : ""}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}>Inicio</Link>
        <Link to="/servicios" onClick={() => setMenuOpen(false)}>Productos</Link>
        <Link to="/nosotros" onClick={() => setMenuOpen(false)}>Quiénes Somos</Link>
        <Link to="/contacto" onClick={() => setMenuOpen(false)}>Contacto</Link>
      </div>
    </nav>
  );
}

export default Navbar;
